import React from 'react';

const LogsTable = ({ logs, filter }) => {
    const filteredLogs = filter === 'all' ? logs : logs.filter(log => log.action === filter);

    return (
        <div className="admin-table-wrapper">
            <div className="admin-table-scroll">
                <table className="admin-data-table admin-logs-table">
                    <thead>
                        <tr>
                            <th>Time</th>
                            <th>Admin</th>
                            <th>Action</th>
                            <th>Game</th>
                            <th>IP</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredLogs.map(log => (
                            <tr key={log.id} className="admin-table-row">
                                <td className="admin-table-cell">{new Date(log.createdAt).toLocaleString()}</td>
                                <td className="admin-table-cell">{log.admin?.username || 'Unknown'}</td>
                                <td className="admin-table-cell">
                                    <span className={`admin-action-badge admin-action-${log.action}`}>{log.action}</span>
                                </td>
                                <td className="admin-table-cell">{log.game?.name || log.gameFolder}</td>
                                <td className="admin-table-cell">{log.ipAddress}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default LogsTable;